<canvas #canvas (window:resize)="resize()">
</canvas>
